import React, { useMemo } from 'react'

import type { CartItemId } from 'models/purchaseFlowRevamp'

import { usePfStore } from '../../store'
import { makeConfigKey } from '../../store/slices/productConfigSlice'
import { useMeasurementQuoteSync } from './useMeasurementQuoteSync'

const MeasurementQuoteSync: React.FC<{ cartItemId: CartItemId }> = ({ cartItemId }) => {
  useMeasurementQuoteSync(cartItemId)
  return null
}

/**
 * Keeps every measurement line on its quoted price for the whole flow. The quote is the price; the
 * catalogue's figure is only a carrier, and anything that rewrites the line — the product drawer's
 * "Save changes" among them — would otherwise leave it on that carrier price outside the configuration step.
 */
export const MeasurementQuoteSyncs: React.FC = () => {
  const items = usePfStore((s) => s.items)
  const configs = usePfStore((s) => s.productConfigs)
  const measurementLines = useMemo(
    () => items.filter((item) => makeConfigKey(item.id, 'measurement') in configs).map((item) => item.id),
    [items, configs]
  )
  return <>{measurementLines.map((id) => <MeasurementQuoteSync key={id} cartItemId={id} />)}</>
}
